import React from "react";
import Header from "./components/Header";
import Buttons from "./components/Buttons";
import FormHeader from "./components/FormHeader";
import Tabs from "./components/Tabs";
import { useAddEditViewController } from "./hooks";
import clsx from "clsx";

const AddEditView: React.FC = () => {
  const controller = useAddEditViewController({});

  return (
    <>
      <Header id={controller.id} view={controller.view} edit={controller.edit} loading={controller.getContentLoading} transactionStatus={controller.formData.status} onDelete={controller.handleDeleteClick} />

      <div className={clsx("card", "mb-6")}>
        <FormHeader formData={controller.formData} id={controller.id || ''} view={controller.view} />

        <hr className="m-0" />

        <Tabs tab={controller.tab} add={!controller.edit && !controller.view} onTabChange={controller.handleTabChange} />

        <hr className="m-0" />

        {controller.formContent}

        <hr className="m-0" />

        <Buttons
          loading={controller.loading}
          actionTwoLoading={controller.actionTwoLoading}
          view={controller.view}
          edit={controller.edit}
          tab={controller.tab}
          onSubmit={controller.handleSubmit}
          onCancel={controller.handleCancel}
        />
      </div>
      {controller.unsavedChangesModal}
      {controller.deleteModal}
    </>
  );
};

export default AddEditView;
